// modules
import { cloneDeep, flow, forOwn, get, isNull, reduce } from 'lodash'
import moment from 'moment'
import { createSelector } from 'reselect'

// constants
import { BROADCAST_DATE_TYPE_LIST, MODULE_LIST } from 'src/constants'

const broadcast$ = (state) => state.company.broadcast
const profile = (state) => state.user.profile

export const broadcastMessageValues$ = createSelector(
  broadcast$,
  (broadcast) => broadcast.messageValues
)

export const broadcastMessageList$ = createSelector(
  broadcast$,
  (broadcast) => broadcast.messageList
)

export const broadcastMessageListProps$ = createSelector(
  broadcast$,
  (broadcast) => broadcast.messageListProps
)

export const broadcastValues$ = createSelector(broadcast$, (broadcast) => {
  const updBroadcastValues = flow(cloneDeep, (vals) =>
    reduce(
      vals,
      (result, item, key) => {
        switch (key) {
          case 'frequencyDate':
            result[key] = isNull(item)
              ? null
              : { date: moment(item), time: moment(item) }
            result.now = isNull(item)
              ? get(BROADCAST_DATE_TYPE_LIST, [0, 'value'])
              : get(BROADCAST_DATE_TYPE_LIST, [1, 'value'])
            break

          case 'targetAudience':
            result[key] = {}

            forOwn(item, (value, valKey) => {
              const valKeys = Object.keys(value)

              result[key][valKey] =
                valKey === 'isAppInstalled'
                  ? typeof value === 'string'
                    ? value
                    : valKeys[0]
                  : valKeys
            })
            break

          default:
            result[key] = item
            break
        }

        return result
      },
      {}
    )
  )(get(broadcast, 'broadcastValues', {}))

  return updBroadcastValues
})

export const broadcastList$ = createSelector(
  broadcast$,
  (broadcast) => broadcast.broadcastList
)

export const broadcastPatientList$ = createSelector(
  broadcast$,
  (broadcast) => broadcast.broadcastPatientList
)

export const broadcastEnable$ = createSelector(
  profile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter((item) => item.name === MODULE_LIST.broadcast).length
)
